import React, { Component } from 'react';
import Chart from "react-apexcharts";
import ajaxCallStation from '../../util/remote/ajaxCallStation';
import Loader from '../Common/Loader';

class CallsCategoriesChart extends Component {

    state = {
        testing: false,
        statData: false,
        series: [],
        options: {}
    };

    setSeries = (calls) => {
        this.setState({
          series: [
            {
              name: 'Direct Calls',
              type: 'line',
              data: calls.gsm
            },
            {
              name: 'Buzz Voice Calls',
              type: 'line',
              data: calls.buzz_voice
            },
            {
              name: 'Buzz Video Calls',
              type: 'line',
              data: calls.buzz_video
            }
          ]
        });
    };

    setOptions = (months) => {
        this.setState({
          options: {
            chart: {
              type: 'line', 
            //   stacked: true,
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                columnWidth: '90%' ,
                horizontal: false,

              }
            },
            colors: ['#43e794', '#03a9f4', '#FF6600'],
            stroke: {
              width: [4, 4, 4], // Set stroke width for each series
              curve: 'smooth' 
            },
            fill: {
              opacity: [0.85, 0.25, 1], // Set different opacity for each series
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
              }
            },
            labels: months, // Set the labels as months
            markers: {
              size: 0
            },
            yaxis: {
              title: {
                display: false
              },
              min: 0,
              tickAmount: 5
            },
            legend: {
              display: false,
              position: 'top'
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if (typeof y !== "undefined") {
                    return y.toFixed(0) + " calls"; // Fix the concatenation here
                  }
                  return y;
                }
              }
            },
            grid: {
              borderColor: '#f1f1f1'
            }
          }
        });
    };
  

    getCallsSum = async () => {
        const server_response = await ajaxCallStation.callsSum();
        if (server_response.status === 'OK') {
          this.setState(
            {
              statData: server_response.details,
            },
            () => {
              const data = this.state.statData;
              const months = [];
              const calls = {
                gsm: [],
                buzz_voice: [],
                buzz_video: []
                
              };
      
              // Loop through the months and collect the totals
              Object.keys(data.months).forEach((index) => {
                months.push(data.months[index]);
                // Initialize the totals for each category for the current month
                const gsmTotal = data.totals.gsm[index] ? data.totals.gsm[index].total * 1 : 0;
                const buzzVoiceTotal = data.totals.buzz_voice[index] ? data.totals.buzz_voice[index].total * 1 : 0;
                const buzzVideoTotal = data.totals.buzz_video[index] ? data.totals.buzz_video[index].total * 1 : 0;
                
      
                // Push the totals into the corresponding category array
                calls.gsm.push(gsmTotal);
                calls.buzz_voice.push(buzzVoiceTotal);
                calls.buzz_video.push(buzzVideoTotal);
                
                
              });
      
              // Set options for months
              this.setOptions(months);
      
              // Set series data for the three categories: buzz_voice, buzz_video, gsm
              this.setSeries(calls);
            }
          );
        }
    };

    componentDidMount() {
        this.getCallsSum()
    }

    render() {
        return (<>
                <div className="card-option d-flex">
                <div>
                    <h6 className="card-title mb-1">Calls</h6>
                    <p className="text-muted card-sub-title">Number of calls according to the different providers each month</p>
                </div>
                <div className="card-option-title ml-auto">
                    <div className="btn-group p-0">
                    
                    <button className="btn btn-light btn-sm" type="button">This Year</button>
                                    
                    </div>
                </div>
                </div>
                <div>

                {this.state.statData && this.state.options && this.state.series && <Chart
                                                                                        options={this.state.options}
                                                                                        series={this.state.series}
                                                                                        height={250}
                                                                                    /> }
                {!this.state.statData && <Loader/>}

                </div></>
            
        );
    }
}

export default CallsCategoriesChart;